///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//

const { default: axios } = require("axios");

///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm = abcsetup.three_pm || {};
abcsetup.three_pm.price_change_resubmission = abcsetup.three_pm.price_change_resubmission || {};
abcsetup.three_pm.price_change_resubmission.index = abcsetup.three_pm.price_change_resubmission.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm.price_change_resubmission.index = {

    init: function () {
        $(document).on('click', 'a.count_of_items[data-id]', function (e) {
            console.log("Querying Items for ThreePMPriceChange Id - "  + $(this).data('id'));
            axios.get('/api/three_pm/price_change/'+$(this).data('id')+'/items')
                .then(response => {
                    console.log("Items Queried - " + response.data.items.length);
                    let items = response.data.items;
                    let table = 
                    '<table class="table"> \
                        <span>Displaying first 10 items...</span> \
                        <thead> \
                            <th>SAP Num</th> \
                            <th>New Price</th> \
                            <th>Effective Date</th> \
                        </thead> \
                    <tbody>';
                    if (items.length > 0) {
                        items.forEach(item => {
                            table += '<tr>';
                            table += '<td>' + item.sap_num + '</td>';
                            table += '<td>$' + item.new_price + '</td>';
                            table += '<td>' + item.effective_date + '</td>';
                            table += '</tr>';
                        });
                        table += '</tbody></table><hr><div><a class="btn btn-sm btn-primary m-2" href="/three_pm/price_change_resubmission/'+$(this).data('id')+'/create">View All Items</span></a>';
                    }

                    $(this).addClass('item_popover').popover({
                        container: 'body',
                        placement: 'top',
                        html: true,
                        trigger: 'click',
                        template: '<div class="popover datatable-filter" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
                        content: table,
                    }).popover('show');
                })
                .catch((error) => {
                    console.log(error);
                });
        });

    }
}